import React from 'react';
import TextInput from "../TextInput";
import CheckboxField from "../CheckboxField";
import RadioField from "../RadioField";

const SurveyField = ({question, control, index,type}) => {
    if (question.type === "TEXT") {
        return <TextInput control={control} require={question.require} label={`${index + 1}. ${question.title}`}
                          name={`${question.questionId}`}  answerId={question.answerList[0]?.answerId}/>
    }
    if (question.type === "MULTIPLE_CHOICE") {
        return <CheckboxField control={control} type={type} listAnswer={question.answerList} require={question.require} label={`${index + 1}. ${question.title}`}
                              name={`${question.questionId}`}/>
    }
    if (question.type === "SINGLE_CHOICE") {
        return <RadioField control={control} type={type} listAnswer={question.answerList} require={question.require} label={`${index + 1}. ${question.title}`}
                              name={`${question.questionId}`}/>
    }

    return (
        <></>
    )
}

export default SurveyField